﻿/**
 * SASS Burger Menu
 *
 */

(function ($) {  

   function spacebarclickredirectfuntion() {
      $(document).on('focusin', '.button-block .listitems a', function (event) {
         var thisurl = $(this).attr('href');

         //GO TO LINK WHEN USER HITS SPACEBAR (KEYCODE 32)
         window.onkeydown = function (event) {
            if (event.keyCode === 32) {
               event.preventDefault();
                  window.location.href = thisurl;
            }
         }
      });
   }  

   //run accessibility function on initial load
   spacebarclickredirectfuntion();
}(jQuery));